module.exports = __webpack_public_path__ + "static/media/pic4.27da6c14.png";